import { CancellableResult } from '../../../common/result';
import faceAuthentication, { SearchAuthentication } from '../../../services/faceAuthentication';
import StepWorker, { StepWorkerResult } from './StepWorker';

export default class FaceSearchStep implements StepWorker {
  public requiresInit = false;

  public data: SearchAuthentication | undefined;

  public async processStep(): Promise<StepWorkerResult> {
    const result = await faceAuthentication.search();
    if (result.isCancelled()) {
      return { result: CancellableResult.cancelled(result.getDetail()) };
    }

    if (result.isFailed()) {
      return { result: CancellableResult.failed(result.failure(), result.getDetail()) };
    }

    this.data = result.success();
    return {
      result: CancellableResult.noValueSuccess(result.getDetail()),
    };
  }
}
